// external dependencies
import React from 'react'
import { object } from 'prop-types'
import { Link, graphql } from 'gatsby'
import styled from '@emotion/styled'

// components
import Layout from 'components/layout/Map'

// styled components
const CatCard = styled.div`
	background: #8142bc;
	border: 3px solid #c38bf5;
	border-radius: 0px 20px;
	box-sizing: border-box;
	margin-bottom: 20px;
	padding: 20px;
	width: 100%;

	@media (min-width: 650px) {
		width: 48%;
	}

	@media (min-width: 900px) {
		width: 30%;
	}
`

const CatName = styled.div`
	color: #5b357d;
	font-size: 45px;
	font-weight: bolder;
	text-align: right;
	z-index: -1;
`

const StyledLink = styled(Link)`
	color: #fff;
`

const Main = styled.main`
	background: #241333;
	padding: 20px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-evenly;

	* {
		box-sizing: border-box;
	}

	a {
		color: #fff;
	}
`

const IndexPage = ({ data }) => {
	const { edges } = data.allMdx

	return (
		<Layout>
			<Main>
				{edges.map(({ node }) => {
					const { category, template, path } = node.frontmatter

					return (
						<CatCard key={`${template}${category}card`}>
							<div key={`${template}${category}`}>
								<StyledLink to={path}>
									{template} :: {category}
								</StyledLink>
							</div>

							<CatName>{category}</CatName>
						</CatCard>
					)
				})}
			</Main>
		</Layout>
	)
}

IndexPage.propTypes = {
	data: object,
}

export default IndexPage

export const pageQuery = graphql`
	query {
		allMdx(filter: { frontmatter: { component: { eq: "page" } } }) {
			edges {
				node {
					id
					frontmatter {
						path
						template
						category
					}
				}
			}
		}
	}
`
